<template>
  <div>
    <div v-if="complete" class="py-5 px-10 bg-yellow-brand text-blue-dark mb-5 rounded-lg">
      <p>{{ successMessage }}</p>
    </div>
    <div v-else class="bg-white rounded-lg p-5">
      <form @submit.prevent="onSubmit">
        <fieldset>
          <div class="flex mb-5 flex-col sm:flex-row">
            <div class="flex-1 mb-5 sm:mb-0">
              <label for="settingsName" class="label block mb-2">Name</label>
              <input type="text" name="name" placeholder="name" class="input block w-full bg-gray-100" v-model="name"
                required>
              <error-message :errors="getErrors('name')"
                error-classes="my-2 bg-red-400 text-blue-extradark rounded p-2"></error-message>
            </div>
            <div class="flex-1 ml-0 sm:ml-5">
              <label for="settingsEmail" class="label block mb-2">Account Email</label>
              <input type="email" name="email" placeholder="name@email.com" class="input block w-full bg-gray-100"
                 v-model="email" required>
              <error-message :errors="getErrors('email')"
                error-classes="my-2 bg-red-400 text-blue-extradark rounded p-2"></error-message>
            </div>
          </div>
          <div class="my-4">
            <label class="text-sm flex items-center">
              <div class="inline-block h-5 w-5 relative cursor-pointer mr-2.5">
                <input type="checkbox" name="agree_to_signup"
                  class="custom-checkbox h-5 w-5 bg-white rounded checked:bg-yellow-brand cursor-pointer bg-gray-100" required>
                <svg class="checkbox-tick h-4 w-4 absolute pin-c">
                  <use xlink:href="/svg/sprite.svg#icon-tick"></use>
                </svg>
              </div>
              {{ checkboxMessage }}
            </label>
          </div>
          <button type="submit"
            class="button block min-w-0 max-w-sm mx-auto w-full bg-yellow-brand text-blue-dark transition-colors hover:bg-yellow-light">
            {{ submitButtonLabel }}
          </button>
        </fieldset>
        <div v-if="errorMessage" class="text-center mt-2">
          <div class="my-4 p-4 bg-red-400 text-blue-extradark rounded text-left">{{ errorMessage }}</div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Route from '../src/Route';
import HandlesErrors from './Mixins/HandlesErrors';
import ErrorMessage from './ErrorMessage.vue';

export default {
  mixins: [
    HandlesErrors,
  ],
  components: {
    ErrorMessage,
  },
  props: {
    formIdentifier: {
      type: String,
      required: true,
    },
    formType: {
      type: String,
      required: true,
    },
    checkboxMessage: {
      type: String,
      required: true,
    },
    submitButtonLabel: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      required: true,
    },
    mailerTag: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sending: false,
      complete: false,
      name: '',
      email: '',
    };
  },
  computed: {
    buttonText() {
      if (this.sending) {
        return 'Sending...';
      }

      if (this.complete) {
        return 'Done!';
      }

      return this.submitButtonLabel;
    }
  },
  methods: {
    onSubmit() {
      this.resetErrors();
      this.sending = true;

      axios
        .post(Route('formsubmissions.store'), {
          type: this.formType,
          identifier: this.formIdentifier,
          name: this.name,
          email: this.email,
          tag: this.mailerTag,
          url: window.location.href,
        })
        .then(() => {
          this.complete = true;
        })
        .catch(this.handleXHRErrors)
        .then(() => {
          this.sending = false;
        });
    }
  }
}
</script>
